import { IconDefinition, faFile } from '@fortawesome/free-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { ReactElement } from 'react';
import { NavLink } from 'react-router-dom';
import { Badge } from '.';
import { Intent } from '../types';
import classNames from '../utilities/class-names';
import './MenuItem.scss';

type MenuItemProps = {
  className?: string;
  icon?: IconDefinition;
  title?: string;
  link?: string;
  count?: number;
  tooltipId?: string;
  end?: boolean;
};

function countToIntent(count: number): Intent {
  if (count > 4) {
    return 'danger';
  }

  if (count > 2) {
    return 'warning';
  }

  return 'success';
}

export function MenuItem({
  className,
  icon = faFile,
  title,
  link,
  count,
  tooltipId,
  end,
}: MenuItemProps): ReactElement {
  return (
    <NavLink
      to={link ?? '/'}
      className={({ isActive }) =>
        classNames('menu-item', isActive ? 'active' : undefined, className)
      }
      data-tooltip-id={tooltipId}
      data-tooltip-content={title ?? ''}
      data-tooltip-place="right"
      end={end}
    >
      <FontAwesomeIcon icon={icon} />
      <Badge intent={countToIntent(count ?? 0)} count={count} show={!!count} />
    </NavLink>
  );
}
